// 广告下单
import React from "react";
import { Card, Row } from "antd";

import Description from "./Description";

const ProQqNew2 = ({ proinfo, title }) => {
  const data = proinfo || {};
  return (
    <Card title="产品明细">
      <h3 className="order_pro_title">{title}</h3>
      <div style={{ paddingLeft: "50px" }}>
        <Row>
          <Description term="类型">{data.c_wei_advtype}</Description>
          <Description term="预存费">{data.c_storefee}</Description>
          <Description term="服务费">{data.c_servicefee}</Description>
        </Row>
        <Row>
          <Description term="打款金额">{data.c_playmoney}</Description>
          <Description term="备注">{data.c_advmark}</Description>
        </Row>
      </div>
    </Card>
  );
};

export default ProQqNew2;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ProAd.js